import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

const REVIEW_TEXT =
  "Il tuo account è in revisione per un controllo di sicurezza. Le azioni sono temporaneamente bloccate. Verrai sbloccato automaticamente al termine della revisione.";

// La sospensione manuale mostra lo stesso testo: all'utente non serve sapere
// se e' partita dal sistema o da un admin.
const REASON_TEXT: Record<string, string> = {
  sexual_minors_review: REVIEW_TEXT,
  admin_manual: REVIEW_TEXT,
};

export function SuspensionBanner() {
  const { user } = useAuth();
  const u = user as any;
  if (!u?.suspendedAt) return null;
  const message =
    REASON_TEXT[u.suspendedReason] ||
    "Il tuo account è temporaneamente sospeso. Le azioni sono bloccate in attesa di revisione.";

  return (
    <div
      role="alert"
      className="fixed bottom-[72px] md:bottom-4 left-1/2 -translate-x-1/2 z-[10001] w-[calc(100%-1.5rem)] max-w-2xl bg-amber-500 text-white shadow-lg rounded-lg"
    >
      <div className="px-4 py-3 flex items-start gap-3">
        <ShieldAlert className="w-5 h-5 shrink-0 mt-0.5" />
        <div className="text-sm leading-relaxed">
          <strong className="font-semibold">Account in revisione.</strong> {message}
        </div>
      </div>
    </div>
  );
}
